import * as React from 'react'

const sizeDefault = {
  x: 36,
  y: 16,
}

export interface IProps {
  size?: { x: number; y: number }
  style?: React.CSSProperties
}
export const Round: React.FCC<IProps> = ({ size = sizeDefault, style }) => (
  <svg
    width={size.x}
    height={size.y}
    viewBox="0 0 36 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M5 5H35V4H5C2.79 4 1 5.79 1 8C1 10.21 2.79 12 5 12H35V11H5C3.343 11 2 9.657 2 8C2 6.343 3.343 5 5 5Z"
      fill="var(--figma-color-text, rgba(0, 0, 0, 0.8))"
    />
  </svg>
)
